import { render, staticRenderFns } from "./help-dialog.vue?vue&type=template&id=91159b3e&scoped=true&"
import script from "./help-dialog.vue?vue&type=script&lang=js&"
export * from "./help-dialog.vue?vue&type=script&lang=js&"
import style0 from "./help-dialog.vue?vue&type=style&index=0&id=91159b3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91159b3e",
  null
  
)

export default component.exports